import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Permission } from 'src/app/constants/permission.constant';
import { AuthService } from 'src/app/services/auth.service';
import { ProductCreateComponent } from 'src/app/components/home/products/product-create/product-create.component';

@Component({
  selector: 'app-add-products-action',
  templateUrl: './add-products-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class AddProductsActionComponent implements OnInit {
  @Output() actionComplete = new EventEmitter<void>();
  @Output() visibilityDeclared = new EventEmitter<boolean>();

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
  ) {}

  get canShow(): boolean {
    return this.authService.hasPermission(Permission.ProductsFull);
  }

  ngOnInit(): void {
    Promise.resolve().then(() => this.visibilityDeclared.emit(this.canShow));
  }

  onAdd(): void {
    const dialogRef = this.dialog.open(ProductCreateComponent);
    dialogRef.afterClosed().subscribe(() => {
      this.actionComplete.emit();
    });
  }
}
